import { BaseChipPropTypes, Chip } from './Chip'
import { Stack } from '@mui/material'
import { tokens } from 'ComponentLibrary'

export type ChipListPropTypes<ChipValueType> = {
    chips: BaseChipPropTypes<ChipValueType>[]
    toggleChip?: (value: ChipValueType) => void
    deleteChip?: (value: ChipValueType) => void
    disabled?: boolean
    noWrap?: boolean
}

export function ChipList<ChipValueType>({ chips, toggleChip, deleteChip, disabled, noWrap }: ChipListPropTypes<ChipValueType>) {
    return (
        <Stack direction="row" gap={tokens.SizingSpacing150} flexWrap={noWrap ? 'nowrap' : 'wrap'}>
            {chips.map((chip) => (
                <Chip
                    key={chip.label}
                    value={chip.value}
                    label={chip.label}
                    selected={chip.selected}
                    toggleChip={toggleChip}
                    deleteChip={deleteChip}
                    disabled={chip.disabled || disabled}
                    icon={chip.icon}
                />
            ))}
        </Stack>
    )
}
